export const Header = ({
  language,
  onToggle,
}: {
  language: "tr" | "en"
  onToggle: (l: "tr" | "en") => void
}) => {
  return (
    <div className="header">
      <h1>DECISION ZERO</h1>
      <div className="lang">
        <button onClick={() => onToggle("en")} disabled={language === "en"}>EN</button>
        <button onClick={() => onToggle("tr")} disabled={language === "tr"}>TR</button>
      </div>
    </div>
  )
}